// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__nqlfp","alert":"SettungsInbox_alert__FoZe-"};